import { Routes, Route } from "react-router-dom";
import WebsiteLayout from "./layouts/WebsiteLayout";
import PanelLayout from "./layouts/PanelLayout";
import LoginCustomer from "./auth/LoginCustomer";
import LoginFleetOwner from "./auth/LoginFleetOwner";
import SignupCustomer from "./auth/SignupCustomer";
import SignupFleetOwner from "./auth/SignupFleetOwner";
import Home from "./website/pages/Home";
import Overview from "./panel/pages/Overview";
import ProtectedRoute from "./routes/ProtectedRoute";
import Profile from "./panel/pages/Profile";
import MyCar from "./panel/pages/MyCar";
import PanelLayoutCustomer from "./layouts/PanelLayoutCustomer";
import BookRide from "./panelCustomer/pages/BookRide";
import MyBooking from "./panelCustomer/pages/MyBooking";
import OverviewCust from "./panelCustomer/pages/OverviewCust";
import ProfileCust from "./panelCustomer/pages/ProfileCust";

function App() {
  return (
    <>
      <Routes>
        <Route element={<WebsiteLayout />}>
          <Route path="/" element={<Home />} />
        </Route>

        <Route path="/login_customer" element={<LoginCustomer />} />
        <Route path="/login_fleetowner" element={<LoginFleetOwner />} />
        <Route path="/signup_customer" element={<SignupCustomer />} />
        <Route path="/signup_fleetowner" element={<SignupFleetOwner />} />

        <Route element={<ProtectedRoute requiredRole="owner" />}>
          <Route element={<PanelLayout />}>
            <Route path="/panel" element={<Overview />} />
            <Route path="/panel/cars" element={<MyCar />} />
            <Route path="/panel/profile" element={<Profile />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute requiredRole="customer" />}>
          <Route element={<PanelLayoutCustomer />}>
            <Route path="/panel_customer" element={<OverviewCust />} />
            <Route path="/panel_customer/bookride" element={<BookRide />} />
            <Route path="/panel_customer/booking" element={<MyBooking />} />
            <Route path="/panel_customer/profile" element={<ProfileCust />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
